import { put, takeEvery, fork, takeLatest } from "redux-saga/effects";
import { setError, setSuccess, startLoading } from "../store/appSlice";
import {
  fetchCashManagementAccounts,
  setList,
  setItem,
  fetchCashManagementAccount,
  updateCashManagementAccount,
  createCashManagementAccount,
  // selectTestCashManagementResponse,
  // testCashManagementSettlement,
  setCashManagementAccountActiveFlag,
  cashManagementOperationPaths,
  updateItem,
  sendTestSettlementBatch,
} from "../store/cashManagementSlice";

// import * as CashAccountFakeApi from "../fakeApi/CashManagement";
import * as CashManagementAccountApi from "../api/CashManagement";
import { callApi } from "./helpers/api";
import { CashManagementAccount } from "../models/CashManagement";
import { push } from "connected-react-router";
import { UUID } from "../utils";

function* fetchCashAccountsSaga({
  payload,
}: {
  payload: {
    id: string;
    active: boolean;
  };
  type: string;
}) {
  const { id, active = undefined } = payload;
  const { listing: operationPath } = cashManagementOperationPaths(id);

  yield put(startLoading(operationPath));

  try {
    const data = yield callApi(
      CashManagementAccountApi.getCashManagementAccounts,
      id,
      active
    );
    yield put(setList(data));
    yield put(setSuccess(operationPath));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* fetchCashAccountSaga({
  payload,
}: {
  payload: {
    id: string;
  };
  type: string;
}) {
  const { id } = payload;
  const { details: operationPath } = cashManagementOperationPaths(id);
  yield put(startLoading(operationPath));
  try {
    const item = yield callApi(
      CashManagementAccountApi.getCashManagementAccount,
      id
    );
    yield put(setItem({ id, item }));
    yield put(setSuccess(operationPath));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* updateCashAccountSaga({
  payload,
}: {
  payload: { id: string; data: CashManagementAccount };
  type: string;
}) {
  const { id, data } = payload;

  const { update: operationPath } = cashManagementOperationPaths(id);
  yield put(startLoading(operationPath));

  try {
    const account = yield callApi(
      CashManagementAccountApi.patchCashManagementAccount,
      id,
      data
    );
    yield put(updateItem({ id, itemPart: account }));
    yield put(setSuccess(operationPath));
    yield put(
      push(
        `/configuration/customers/${account.customer}/cash-management/account/${account.id}`
      )
    );
  } catch (error) {
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* createCashAccountSaga({
  payload,
}: {
  payload: { id: string; data: CashManagementAccount };
  type: string;
}) {
  const { id, data } = payload;

  const { create: operationPath } = cashManagementOperationPaths(id);
  yield put(startLoading(operationPath));

  try {
    const account = yield callApi(
      CashManagementAccountApi.postCashManagementAccount,
      id,
      data
    );
    yield put(setItem({ id, item: account }));
    yield put(setSuccess(operationPath));
    yield put(
      push(
        `/configuration/customers/${id}/cash-management/account/${account.id}`
      )
    );
  } catch (error) {
    yield put(
      setError({
        path: operationPath,
        error: error,
      })
    );
  }
}

function* setCashManagementAccountActiveFlagSaga({
  payload,
}: {
  payload: { id: string; data: CashManagementAccount };
  type: string;
}) {
  const { id, data } = payload;
  const { setActiveFlag: operationPath } = cashManagementOperationPaths(id);
  yield put(startLoading(operationPath));
  try {
    const account = yield callApi(
      CashManagementAccountApi.patchCashManagementAccount,
      id,
      data
    );
    yield put(updateItem({ id, itemPart: { active: account.active } }));
    yield put(setSuccess(operationPath));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* sendTestSettlementBatchSaga({
  payload,
}: {
  payload: { id: UUID };
  type: string;
}) {
  const { id } = payload;
  const {
    sendTestSettlementBatch: operationPath,
  } = cashManagementOperationPaths(id);
  yield put(startLoading(operationPath));

  try {
    yield callApi(CashManagementAccountApi.testCashManagementSettlement, id);
    yield put(setSuccess(operationPath));
  } catch (error) {
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* watchFetchCashManagementAccounts() {
  yield takeEvery(fetchCashManagementAccounts.type, fetchCashAccountsSaga);
}

function* watchFetchCashManagementAccount() {
  yield takeEvery(fetchCashManagementAccount.type, fetchCashAccountSaga);
}

function* watchUpdateCashManagementAccount() {
  yield takeEvery(updateCashManagementAccount.type, updateCashAccountSaga);
}

function* watchCreateCashManagementAccount() {
  yield takeEvery(createCashManagementAccount.type, createCashAccountSaga);
}

function* watchSendTestSettlementBatch() {
  yield takeEvery(sendTestSettlementBatch.type, sendTestSettlementBatchSaga);
}

function* watchSetCashManagementAccountActiveFlagSaga() {
  yield takeLatest(
    setCashManagementAccountActiveFlag.type,
    setCashManagementAccountActiveFlagSaga
  );
}

export function* CashSaga() {
  yield fork(watchFetchCashManagementAccounts);
  yield fork(watchFetchCashManagementAccount);
  yield fork(watchUpdateCashManagementAccount);
  yield fork(watchCreateCashManagementAccount);
  yield fork(watchSendTestSettlementBatch);
  yield fork(watchSetCashManagementAccountActiveFlagSaga);
}
